import React, { Component } from 'react'
import { HuaweiSport } from './components/HuaweiSport'

class HuaweiSportRedirect extends Component {
  render() {
    return (
      <div>
        <HuaweiSport {...this.props} />
      </div>
    )
  }
}

export default HuaweiSportRedirect



// WEBPACK FOOTER //
// ./src/modules/sport/index.js